import request from '@/utils/request'

//根据id查看人才信息
export function getPersonListById(data) {
  return request({
    url: '/person/listById',
    method: 'get',
    params: data
  })
}

//查询一览
export function selectCandidateRecords(data) {
  return request({
    url: '/CandidateRecords/selectCandidateRecords',
    method: 'post',
    data
  })
}

//查看单个
export function getListByOne(data) {
  return request({
    url: '/CandidateRecords/listById',
    method: 'get',
    params: data
  })
}

//删除
export function deleteRecords(data) {
  return request({
    url: '/CandidateRecords/delete',
    method: 'get',
    params: data
  })
}

//修改
export function updateRecords(data) {
  return request({
    url: '/CandidateRecords/update',
    method: 'post',
    data
  })
}

//新增
export function addRecords(data) {
  return request({
    url: '/CandidateRecords/save',
    method: 'post',
    data
  })
}
